// client/src/pages/Admin/ResourceManager/hooks/useResources.ts
import { useState, useEffect, useCallback } from 'react';
import { Resource, ResourceStatus } from '../../../../shared/models/Resource';
import { resourceService } from '../services/resourceService';

export const useResources = () => {
    const [resources, setResources] = useState<Resource[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const fetchResources = useCallback(async (): Promise<void> => {
        setLoading(true);
        setError('');
        try {
            const data = await resourceService.fetchResources();
            setResources(data);
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : 'Failed to load resources';
            setError(errorMsg);
            setResources([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchResources();
    }, [fetchResources]);

    return {
        resources,
        setResources,
        loading,
        error,
        fetchResources,
        loadResources: fetchResources,
        removeResource: async (id: string): Promise<void> => {
            await resourceService.deleteResource(id);
            setResources((prev) => prev.filter((resource) => resource._id !== id));
        },
        updateStatus: async (id: string, status: string): Promise<void> => {
            await resourceService.updateResource(id, { status: status as ResourceStatus });
            setResources((prev) =>
                prev.map((resource) =>
                    resource._id === id
                        ? { ...resource, status: status as ResourceStatus, updatedAt: new Date() }
                        : resource
                )
            );
        }
    };
};